import { getRoles } from '../services/roleService';
import { getUsersCreatedBy, getAdminCreatedTree } from '../services/userService';

let _rolesCache = null;

async function loadRolesMap() {
  if (!_rolesCache) {
    const roles = await getRoles();
    _rolesCache = Array.isArray(roles) ? roles : [];
  }
  return new Map(_rolesCache.map(x => [Number(x.role_id), String(x.name || '')]));
}

export async function buildAdminTreeUserIds(rootUserId) {
  const id0 = Number(rootUserId);
  if (!Number.isInteger(id0)) return [];
  // Prefer single-call nested API when available
  try {
    const tree = await getAdminCreatedTree(id0);
    const out = new Set([id0]);
    const walk = (node) => {
      if (!node) return;
      const kids = Array.isArray(node.createdUsers) ? node.createdUsers : [];
      for (const ch of kids) {
        const uid = Number(ch.user_id ?? ch.userId);
        if (Number.isInteger(uid)) out.add(uid);
        walk(ch);
      }
    };
    walk(tree);
    return Array.from(out);
  } catch {
    // Fallback to existing BFS using CreatedBy per admin only
    const roleMap = await loadRolesMap();
    const isAdminRoleId = (rid) => String(roleMap.get(Number(rid)) || '').toUpperCase().replace(/[^A-Z]/g, '') === 'ADMIN';
    const collected = new Set([id0]);
    const visited = new Set([id0]);
    const queue = [id0];
    while (queue.length > 0) {
      const adminId = queue.shift();
      try {
        const children = await getUsersCreatedBy(adminId);
        (children || []).forEach((child) => {
          const uid = Number(child.user_id);
          if (!Number.isInteger(uid)) return;
          collected.add(uid);
          if (isAdminRoleId(child.role_id) && !visited.has(uid)) {
            visited.add(uid);
            queue.push(uid);
          }
        });
      } catch {}
    }
    return Array.from(collected);
  }
}

